// frontend/src/pages/PayrollItems/components/SchedulesBody.tsx
// Pay schedules section body: one card per schedule, clickable to open detail.

import React from "react";
import { ChevronRight } from "lucide-react";
import type { Schedule } from "../types";
import { SCHEDULES } from "../data";
import { BORDER, BG_CARD, TEXT_INK, TEXT_TERTIARY, BADGE } from "../styles";

interface SchedulesBodyProps {
  /** Called when a card is clicked. Parent decides where to navigate. */
  onCardClick: (schedule: Schedule) => void;
}

export default function SchedulesBody({
  onCardClick,
}: SchedulesBodyProps): React.ReactElement {
  return (
    <div>
      {SCHEDULES.map((s) => (
        <div
          key={s.id}
          onClick={() => onCardClick(s)}
          style={{
            border: "0.5px solid " + BORDER,
            borderRadius: 10,
            padding: 18,
            background: BG_CARD,
            display: "flex",
            alignItems: "center",
            gap: 24,
            cursor: "pointer",
            marginBottom: 12,
            flexWrap: "wrap",
          }}
        >
          {/* Name + frequency + optional DEFAULT badge */}
          <div style={{ flex: 1, minWidth: 220 }}>
            {s.isDefault && (
              <div style={{ marginBottom: 8 }}>
                <span style={BADGE}>DEFAULT</span>
              </div>
            )}
            <div style={{ fontSize: 12.5, color: TEXT_TERTIARY }}>{s.freq}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: TEXT_INK, marginTop: 2 }}>
              {s.name}
            </div>
          </div>

          {/* Pay period ends on */}
          <div style={{ minWidth: 140 }}>
            <div style={{ fontSize: 12, color: TEXT_TERTIARY }}>Pay period ends on</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: TEXT_INK, marginTop: 2 }}>
              {s.ends}
            </div>
          </div>

          {/* Next payday */}
          <div style={{ minWidth: 140 }}>
            <div style={{ fontSize: 12, color: TEXT_TERTIARY }}>Next payday</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: TEXT_INK, marginTop: 2 }}>
              {s.payday}
            </div>
          </div>

          <ChevronRight size={18} style={{ color: TEXT_TERTIARY }} />
        </div>
      ))}
    </div>
  );
}